import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { verifyAuth } from '../services/api';

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const hasToken = Boolean(localStorage.getItem('admin_token'));
  // null = still checking, true/false = server verdict
  const [valid, setValid] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!hasToken) return undefined;
    verifyAuth().then((ok) => {
      if (!cancelled) setValid(ok);
    });
    return () => { cancelled = true; };
  }, [hasToken]);

  // No token at all — straight to login, no flash.
  if (!hasToken || valid === false) {
    return <Navigate to="/admin-portal/login" state={{ from: location }} replace />;
  }

  // Token present: render optimistically while the verify call is in
  // flight (a valid session sees no delay); the effect above redirects if
  // it comes back invalid.
  return children;
}
